import { Component, OnInit } from '@angular/core';
import { BookingService } from "../../../shared/services/booking.service";
import { ThrowStmt } from '@angular/compiler';
import { endOfMonth } from 'date-fns';
import { DatePipe } from '@angular/common';
import { TranslateService } from "@ngx-translate/core";
@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {
  ranges = { "اليوم": [new Date(), new Date()],
  'الشهر الحالي': [ new Date(new Date().getFullYear(), new Date().getMonth(), 1), endOfMonth(new Date())]
  ,  'الإسبوع الحالي': [ new Date(new Date().setDate(new Date().getDate() - new Date().getDay())), new Date(new Date().setDate(new Date().getDate() - new Date().getDay()+6))]};
  options: any;
  option2: any;
  option3: any;
  initOpt: any;
  ByDays: any;
  lang:any;
  startDate: any = this.datepipe.transform( new Date(new Date().getFullYear(), new Date().getMonth(), 1), 'yyyy-MM-dd');
  endDate: any = this.datepipe.transform( endOfMonth(new Date()), 'yyyy-MM-dd');
  optionsAppointmentsValuesByMonths: any;
  constructor(
    private bookingService: BookingService,
    public datepipe: DatePipe,
    private translate: TranslateService
  ) { 

 
  }
  isLoading = false;
  StatisticsList = [];
  AppointmentsByCourt = [];
  AppointmentsByMonths = [];
  AppointmentsByDays = [];
  AppointmentsValuesByMonths = [];

  todayDate = [this.datepipe.transform( new Date(new Date().getFullYear(), new Date().getMonth(), 1), 'yyyy-MM-dd') , this.datepipe.transform( endOfMonth(new Date()), 'yyyy-MM-dd') ];

  AppointmentsByMonthsKey: any = [];
  AppointmentsByMonthsValues: any = [];


  async getStatistics() {
    this.isLoading = true;
    const startDate = this.datepipe.transform(this.startDate, 'yyyy-MM-dd');
    const endDate = this.datepipe.transform( this.endDate, 'yyyy-MM-dd');
    let params = {
      start_date  : startDate,
      end_date  :endDate,
    }
    this.bookingService.getStatistics(params).subscribe(
      (response: any) => {
        this.StatisticsList = response?.data;
        this.AppointmentsByCourt = response?.data['AppointmentsByCourt'];
        this.AppointmentsByMonths = response?.data['AppointmentsByMonths'];
        this. AppointmentsValuesByMonths = response?.data['AppointmentsValuesByMonths'];
        this.AppointmentsByDays = response?.data['AppointmentsByDays'];
        this.isLoading = false;
     
        this.options = {
          color: ['#3f5485'],
          xAxis: {
            type: 'category',
            data: this.AppointmentsByMonths['months'],
          },
          yAxis: {
            type: 'value',
          },
          tooltip: {
            trigger: 'item'
          },
          legend: {
            top: '5%',
            left: 'center'
          },
          series: [
            {
              data: this.AppointmentsByMonths['values'],
              type: 'bar',
            },
          ],
        };


        this.optionsAppointmentsValuesByMonths = {
          color: ['#3f5485'],
          xAxis: {
            type: 'category',
            data: this.AppointmentsValuesByMonths['months'],
          },
          yAxis: {
            type: 'value',
          },
          tooltip: {
            trigger: 'item'
          },
          series: [
            {
              data: this.AppointmentsValuesByMonths['values'],
              type: 'bar',
            },
          ],
        };




        this.option2 =
        {
          tooltip: {
            trigger: 'item'
          },

          legend: {
            top: '5%',
            left: 'center'
          },
          series: [
            {
              name: 'اليوم',
              type: 'pie',
              radius: ['40%', '70%'],
              avoidLabelOverlap: false,
              itemStyle: {
                borderRadius: 10,
                borderColor: '#fff',
                borderWidth: 2
              },
              label: {
                show: false,
                position: 'center'
              },
              emphasis: {
                label: {
                  show: true,
                  fontSize: '40',
                  fontWeight: 'bold'
                }
              },
              labelLine: {
                show: false
              },
              data: this.AppointmentsByCourt,
            }
          ]
        },


          this.option3 = {
            tooltip: {
              trigger: 'item'
            },

            legend: {
              top: '5%',
              left: 'center'
            },
            series: [
              {
                name: 'اليوم',
                type: 'pie',
                radius: ['40%', '70%'],
                avoidLabelOverlap: false,
                itemStyle: {
                  borderRadius: 10,
                  borderColor: '#fff',
                  borderWidth: 2
                },
                label: {
                  show: false,
                  position: 'center'
                },
                emphasis: {
                  label: {
                    show: true,
                    fontSize: '40',
                    fontWeight: 'bold'
                  }
                },
                labelLine: {
                  show: false
                },
                data: this.AppointmentsByDays,
              }
            ]
          },
          (err) => {
            this.isLoading = false;
          };
      });


  }



  async ngOnInit() {
    await this.getStatistics();

    this.translate.setDefaultLang('en');
    this.lang = localStorage.getItem('lang') || 'en';
    this.translate.use(this.lang);
    document.documentElement.lang = this.lang;



    //   this.options =  {
    //     xAxis: {
    //       type: 'category',
    //       data:  this.AppointmentsByMonthsKey,
    //     },
    //     yAxis: {
    //       type: 'value'
    //     },
    //     series: [
    //       {
    //         data: this.AppointmentsByMonthsValues,
    //         type: 'bar'
    //       }
    //     ]
    //   };
    this.initOpt = {
      renderer: 'svg',
      width: 700,
      height: 400
    };
    this.ByDays = {
      title: {
        text: 'Total',
        left: 'center',
        top: 'center'
      },
      series: [
        {
          type: 'pie',
          color: ['#0267BC', '#EA5482'],
          data: [
            { value: 1048, name: 'Search Engine' },
            { value: 735, name: 'Direct' },
          ],
          avoidLabelOverlap: false,
          itemStyle: {
            borderRadius: 10,
            borderColor: '#fff',
            borderWidth: 2
          },
          radius: ['50%', '70%']
        }
      ]
    };

    // }
  }


  onChangeDate(result: Date[]): void {

    this.startDate = this.datepipe.transform(result[0], 'yyyy-MM-dd');
    this.endDate = this.datepipe.transform(result[1], 'yyyy-MM-dd');
 
    this.getStatistics();

    }


}
